<template>
<div class="content2">
  <div class="header">
    <el-date-picker
      style="width: 120px"
      v-model="where2.year_month"
      size="mini"
      type="month"
      format="yyyy-MM"
      value-format="yyyy-MM" placeholder="选择月份">
    </el-date-picker>
    <el-button @click="exportExcel">导出报表</el-button>
  </div>
  <div class="body">
    <div class="table-wrap">
      <el-table
        v-loading="loading"
        v-if="tableData" :data="tableData"
        :span-method="objectSpanMethod"
        border class="table-wrap-table" height="60vh">
        <el-table-column label="名称" prop="name" align="center" min-width="180" fixed></el-table-column>
        <el-table-column label="类型" prop="type" align="center" width="120" fixed></el-table-column>
        <el-table-column label="当月计划(实际计划)" prop="plan" align="center" width="140">
          <template slot-scope="scope">
            <span v-if="scope.row.name==='户数'">{{formatMoney(scope.row.plan)}}</span>
            <span v-else>{{formatMoney(scope.row.plan,2)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="当月实际" align="center">
          <el-table-column label="项目诉讼" align="center">
            <el-table-column label="诉调" prop="o_st" align="center" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.name==='户数'">{{formatMoney(scope.row.o_st)}}</span>
                <span v-else>{{formatMoney(scope.row.o_st,2)}}</span>
              </template>
            </el-table-column>
            <el-table-column label="立案" prop="o_la" align="center" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.name==='户数'">{{formatMoney(scope.row.o_la)}}</span>
                <span v-else>{{formatMoney(scope.row.o_la,2)}}</span>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="第三方诉讼" align="center">
            <el-table-column label="诉调" prop="t_st" align="center" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.name==='户数'">{{formatMoney(scope.row.t_st)}}</span>
                <span v-else>{{formatMoney(scope.row.t_st,2)}}</span>
              </template>
            </el-table-column>
            <el-table-column label="立案" prop="t_la" align="center" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.name==='户数'">{{formatMoney(scope.row.t_la)}}</span>
                <span v-else>{{formatMoney(scope.row.t_la,2)}}</span>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="合计" prop="finish" align="center" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.name==='户数'">{{formatMoney(scope.row.finish)}}</span>
              <span v-else>{{formatMoney(scope.row.finish,2)}}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="当月完成率" prop="finish_rate" align="center" width="120">
          <template slot-scope="scope">
            <span>{{scope.row.finish_rate}}</span>
          </template>
        </el-table-column>
        <el-table-column label="回款" prop="collection" align="center" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.name==='户数'">{{formatMoney(scope.row.collection)}}</span>
            <span v-else>{{formatMoney(scope.row.collection,2)}}</span>
          </template>
        </el-table-column>
        <el-table-column label="回款率" prop="collection_rate" align="center" width="120">
          <template slot-scope="scope">
            <span>{{scope.row.collection_rate}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
<!--    <div class="pagination-wrap">-->
<!--      <el-pagination background layout="prev, pager, next" :total="pageData.total*1"-->
<!--                     :page-size="pageData.pageSize*1" :current-page="pageData.page*1"-->
<!--                     @current-change="pageChange"></el-pagination>-->
<!--    </div>-->
  </div>
</div>
</template>

<script>
import {CommonHelp} from "../../common/CommonHelp";
import ButlerHttp from "../../common/ButlerHttp";
import moment from "moment";

export default {
  name: "MonthlyCompletionRate",
  inject:['where','reginWhere'],
  data() {
    return{
      where2:{
        year_month:moment().format("YYYY-MM"),
      },
      loading:false,
      tableData: [],
      pageData:{
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
    }
  },
  mounted() {
    const that=this;
    this.pageChange(1);
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_region":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.area_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.year_month":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
  },
  methods: {
    getList(){
      const that = this;
      that.loading = true;
      let where = {
        ...that.where2,
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id,
        level:that.reginWhere.level,
      }

      ButlerHttp.post("ProjectCollectionProceedingOverview/index2",{
        ...where,
        page: that.pageData.page,
        pageSize: that.pageData.pageSize
      }, res => {
        if (res.code) {
          that.tableData = res.data.list;
        }
        that.loading = false;
      })
    },
    pageChange(i) {
      const that=this;
      that.pageData.page = i;
      CommonHelp.debounce(()=>{
        that.getList()
      },500,that);

    },
    exportExcel(){
      const that=this;
      const loading=that.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let where = {
        ...that.where2,
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id,
        level:that.reginWhere.level,
      }
      ButlerHttp.post("StatisticalTable/projectCollectionProceedingOverviewExcel",{
        ...where,
      },res => {
        loading.close()
        if (res.code) {
          window.open(res.data)
        }else {
          that.$message.error(res.msg);
        }
      })
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const prevRow = this.tableData[rowIndex - 1];
        const currRow = row;

        if (prevRow && prevRow[column.property] === currRow[column.property]) {
          return { rowspan: 0, colspan: 0 };
        } else {
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.tableData.length; i++) {
            if (this.tableData[i][column.property] === currRow[column.property]) {
              rowspan++;
            } else {
              break;
            }
          }
          if (rowspan > 1) {
            return { rowspan: rowspan, colspan: 1 };
          }
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";
.content2{
  .header{
    padding-top: 5px;
    padding-bottom: 10px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #FFFFFF;
  }
  .header-tip{
    margin: 5px 0;
    padding: 5px 10px;
    background-color: #f56c6c;
    color: #FFFFFF;
    border-radius: 4px;
    display: flex;
    flex-direction: row;

    .header-tip-body{
      //width: 500px;
      margin-left: 50px;
      display: flex;
      flex-direction: row;
      //justify-content: space-between;
      .header-tip-body-item{
        margin-left: 50px;
        display: flex;
        flex-direction: row;
      }
    }
  }
  .pagination-wrap{
    margin-top: 10px;
    text-align: center;
  }

  >>>.el-table--border, .el-table--group{
    border: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
    border-right: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border th.el-table__cell, .el-table__fixed-right-patch{
    border-bottom: 1px solid #000000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/report_forms/MonthlyCompletionRate.vue